export enum ContactSubjectEnum {
    BECOME = "become",
    SUBSCRIPTION = "subscription",
    CONTRACT = "contract",
    USAGE = "usage",
    BILLING = "billing",
    MYMEGA = "myMega",
    OTHER = "other"
}

export enum ContactSubSubjectEnum {
    BECOME_SUBSCR = "become_sub",
    BECOME_FOLLOW = "become_follow",
    BECOME_ENERGY = "become_energy",
    SUBSCR_MODIFY = "subscription_modify",
    SUBSCR_CANCEL = "subscription_cancel",
    SIM_ACTIVATE = "contract_activate",
    SIM_CONFIGURE = "contract_configure",
    USAGE_FOLLOW = "usage_follow",
    USAGE_ROAMING = "usage_roaming",
    USAGE_PREMIUM = "usage_premium",
    USAGE_OTHER = "usage_other",
    INV_INVOICE = "billing_invoice",
    INV_PAYMENT = "billing_payment",
    INV_DUNNING = "billing_dunning",
    MYMEGA_USING = "myMega_using",
    MYMEGA_ACCNT = "myMega_account",
    OTHER_TECHNIC = "other_tech",
    OTHER_EXCEPT = "other_except",
}